import * as React from "react";
const IconFilter = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.98633 4.99243H10.9863M10.9863 4.99243C10.9863 6.097 11.8818 6.99243 12.9863 6.99243C14.0909 6.99243 14.9863 6.097 14.9863 4.99243M10.9863 4.99243C10.9863 3.88786 11.8818 2.99243 12.9863 2.99243C14.0909 2.99243 14.9863 3.88786 14.9863 4.99243M3.98633 11.9924H12.9863M19.9863 11.9924H21.9863M19.9863 11.9924C19.9863 13.097 19.0909 13.9924 17.9863 13.9924C16.8818 13.9924 15.9863 13.097 15.9863 11.9924C15.9863 10.8879 16.8818 9.99243 17.9863 9.99243C19.0909 9.99243 19.9863 10.8879 19.9863 11.9924ZM14.9863 4.99243H21.9863M12.9863 18.9924H21.9863M3.98633 18.9924H5.98633M5.98633 18.9924C5.98633 20.097 6.88176 20.9924 7.98633 20.9924C9.0909 20.9924 9.98633 20.097 9.98633 18.9924C9.98633 17.8879 9.0909 16.9924 7.98633 16.9924C6.88176 16.9924 5.98633 17.8879 5.98633 18.9924Z"
      stroke="#1C1C2C"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
export default IconFilter;
